import type { ProjectDto } from '@flowqa/shared';

const upsertProjectsById = (
  projects: ProjectDto[],
  nextProjects: ProjectDto[] | undefined,
): ProjectDto[] => {
  if (!nextProjects || nextProjects.length === 0) {
    return projects;
  }
  const merged = new Map(projects.map((project) => [project.id, project]));
  nextProjects.forEach((project) => {
    merged.set(project.id, project);
  });
  return [...merged.values()];
};

export const resolveShellVisibleProjects = ({
  selectedOrganisationId,
  bootstrapVisibleProjects,
  liveSelectedOrganisationProjects,
}: {
  selectedOrganisationId: string | null;
  bootstrapVisibleProjects: ProjectDto[];
  liveSelectedOrganisationProjects?: ProjectDto[];
}): ProjectDto[] => {
  if (selectedOrganisationId === null) {
    return bootstrapVisibleProjects;
  }
  return upsertProjectsById(bootstrapVisibleProjects, liveSelectedOrganisationProjects);
};

export const mergeShellProjects = ({
  bootstrapProjects,
  liveSelectedOrganisationProjects,
}: {
  bootstrapProjects: ProjectDto[];
  liveSelectedOrganisationProjects?: ProjectDto[];
}): ProjectDto[] => upsertProjectsById(bootstrapProjects, liveSelectedOrganisationProjects);
